import { render, staticRenderFns } from "./createCourse.vue?vue&type=template&id=3da81ce0&scoped=true"
import script from "./createCourse.vue?vue&type=script&lang=js"
export * from "./createCourse.vue?vue&type=script&lang=js"
import style0 from "./createCourse.vue?vue&type=style&index=0&id=3da81ce0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da81ce0",
  null
  
)

export default component.exports